import React from 'react';
import ReactDOM from 'react-dom';
import {inject, observer, Provider} from 'mobx-react';
const Slider = require('react-slick').default;
import store from './store';

import Title from './Title';
import BtnMore from './BtnMore';

@inject('store')
@observer
class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            curNav: 0
        };
    }

    componentDidMount() {
        const {requestData} = this.props.store;
        requestData();

        // 监听页面滚动
        document.addEventListener(
            'scroll',
            () => {
                const top =
                    document.body.scrollTop ||
                    document.documentElement.scrollTop ||
                    window.pageYOffset;
                const areaConfig = [
                    {
                        min: 0,
                        max: 894
                    },
                    {
                        min: 894,
                        max: 2046
                    },
                    {
                        min: 2046,
                        max: 2663
                    },
                    {
                        min: 2663,
                        max: 3039
                    },
                    {
                        min: 3039,
                        max: 3517
                    },
                    {
                        min: 3517,
                        max: 3857
                    },
                    {
                        min: 3857,
                        max: 9000
                    }
                ];

                for (let i = 0; i < areaConfig.length; i++) {
                    const {min, max} = areaConfig[i];
                    if (top >= min && top < max) {
                        this.setState({
                            curNav: i
                        });
                    }
                }
                const headerDom = document.getElementById('header');
                headerDom.style.top = top < 73 ? 73 - top + 'px' : 0;
            },
            false
        );
    }

    handleNavClick(id, index) {
        const dom = document.getElementById(id);
        const headerHeight = 70;

        dom.scrollIntoView(true);

        this.setState({
            curNav: index
        });

        setTimeout(() => {
            const top =
                document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset;
            window.scrollTo(0, top - headerHeight);
        }, 0);
    }

    render() {
        const {popupType, curVideoUrl, showPopup, hidePopup, allData} = this.props.store;

        const BannerSliderSetting = {
            dots: true,
            infinite: true,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: <CustomArrow isNext={true} />,
            prevArrow: <CustomArrow />
        };

        const centerSliderSetting1 = {
            className: 'center-slider center-slider-1',
            centerMode: true,
            infinite: true,
            centerPadding: '21%',
            slidesToShow: 1,
            speed: 500,
            nextArrow: <CustomArrow isNext={true} />,
            prevArrow: <CustomArrow />
        };
        const fadeSliderSetting1 = {
            className: 'fade-slider fade-slider-1',
            fade: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };

        const centerSliderSetting2 = {
            className: 'center-slider center-slider-2',
            centerMode: true,
            infinite: true,
            centerPadding: '21%',
            slidesToShow: 1,
            speed: 500,
            nextArrow: <CustomArrow isNext={true} />,
            prevArrow: <CustomArrow />
        };
        const fadeSliderSetting2 = {
            className: 'fade-slider fade-slider-2',
            fade: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };

        if (!allData.wjzd) {
            return null;
        }
        return (
            <div>
                <Header
                    index={this.state.curNav}
                    callbackFn={(a, b) => this.handleNavClick(a, b)}
                />
                <BannerSlider
                    data={allData.banner}
                    setting={BannerSliderSetting}
                    callbackFn={showPopup}
                />
                <div className="m-bg">
                    <AboutUs
                        data={allData.gywm}
                        setting1={centerSliderSetting1}
                        setting2={fadeSliderSetting1}
                    />
                    <VikingCore data={allData.wjzd} />
                </div>
                <HotRiver
                    data={allData.rmhl}
                    setting1={centerSliderSetting2}
                    setting2={fadeSliderSetting2}
                />
                <AdBanner data={allData.djyh} />
                <HotRecommend data={allData.rmtj} />
                <TravelNotes data={allData.dryj} limit={4} />
                <QuestionAnser data={allData.ylwd} limit={3} />
                <Sidebar />

                {popupType === 'video' ? (
                    <PopupBox>
                        <div className="video-container">
                            <div className="video-box">
                                <video controls>
                                    <source src={curVideoUrl} />
                                </video>
                                <div className="iconfont video-close" onClick={() => hidePopup()}>
                                    &#xf3f4;
                                </div>
                            </div>
                        </div>
                    </PopupBox>
                ) : null}
            </div>
        );
    }
}

// 顶部导航
class Header extends React.Component {
    render() {
        const {index, callbackFn} = this.props;
        const config = [
            {
                id: 'about-us',
                text: '关于我们'
            },
            {
                id: 'viking-core',
                text: '维京之道'
            },
            {
                id: 'hot-river',
                text: '热门河流'
            },
            {
                id: 'ad-banner',
                text: '当季优惠'
            },
            {
                id: 'hot-recommend',
                text: '热门推荐'
            },
            {
                id: 'travel-notes',
                text: '达人游记'
            },
            {
                id: 'question-anser',
                text: '游轮问答'
            }
        ];
        return (
            <div id="header" className="m-header">
                <div className="header-content">
                    <div className="header-left">
                        <a class="logo">
                            <img
                                src="//static.vikingcruises.cn/wp-content/themes/viking-2018/img/common/logo0117.png?v=20190118b"
                                alt="维京游轮"
                            />
                        </a>
                    </div>
                    <div className="header-right">
                        {config.map((v, k) => {
                            return (
                                <a
                                    className={k === index ? 'item item-active' : 'item'}
                                    onClick={() => {
                                        callbackFn && callbackFn(v.id, k);
                                    }}>
                                    <span>{v.text}</span>
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

// 顶部轮播图
class BannerSlider extends React.Component {
    render() {
        const {setting, data, callbackFn} = this.props;
        const {products, sk_eid_pc} = data;
        return (
            <div className="top-slider">
                <Slider {...setting}>
                    {products.map((v, k) => {
                        return (
                            <div className="slide-item" key={k}>
                                <a
                                    onClick={() => {
                                        QNRSK.manual(sk_eid_pc);
                                        // 视频点击弹窗播放
                                        if (v.video_pc) {
                                            callbackFn('video', v.video_pc);
                                        }
                                        // 图片点击跳转
                                        if (v.url_pc) {
                                            window.open(v.url_pc);
                                        }
                                    }}>
                                    {v.video_pc ? (
                                        <div className="video-box">
                                            {/* <video muted autoPlay loop>
                                                <source src={v.video_pc} />
                                                Sorry, your browser doesn't support embedded videos.
                                            </video> */}
                                            <img src={v.img_pc} alt="" />
                                            <span className="iconfont play">&#xf347;</span>
                                        </div>
                                    ) : (
                                        <img src={v.img_pc} />
                                    )}
                                </a>
                            </div>
                        );
                    })}
                </Slider>
            </div>
        );
    }
}
// 关于我们
class AboutUs extends React.Component {
    render() {
        const {data, setting1, setting2} = this.props;
        const {module_name, subtitle, products = [], sk_eid_pc} = data;

        if (!products || !products.length) {
            return false;
        }
        return (
            <div id="about-us" className="m-wrap">
                <Title title={module_name} subtitle={subtitle} />
                <AsNavForSlider
                    eid={sk_eid_pc}
                    data1={products}
                    setting1={setting1}
                    setting2={setting2}>
                    {products.map((v, k) => {
                        return (
                            <div
                                className="item"
                                key={k}
                                onClick={() => {
                                    QNRSK.manual(sk_eid_pc);
                                    if (v.url_pc) {
                                        window.open(v.url_pc);
                                    }
                                }}>
                                <p>{v.desc}</p>
                            </div>
                        );
                    })}
                </AsNavForSlider>
            </div>
        );
    }
}

// 维京之道
class VikingCore extends React.Component {
    render() {
        const {data} = this.props;
        const {module_name, subtitle, products = [], sk_eid_pc} = data;

        if (!products || !products.length) {
            return false;
        }
        return (
            <div id="viking-core">
                <Title title={module_name} subtitle={subtitle} />
                <div className="m-viking-core">
                    {products.map((v, k) => {
                        return (
                            <div
                                className="item"
                                key={k}
                                onClick={() => {
                                    QNRSK.manual(sk_eid_pc);
                                }}>
                                <div className="image">
                                    <img src={v.img_pc} />
                                </div>
                                <div className="wrap">
                                    <div className="desc">{v.desc}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

// 热门河流
class HotRiver extends React.Component {
    render() {
        const {data, setting1, setting2} = this.props;
        const {module_name, subtitle, products = [], more_url_pc, sk_eid_pc} = data;

        if (!products || !products.length) {
            return false;
        }
        return (
            <div id="hot-river" className="m-wrap">
                <Title title={module_name} subtitle={subtitle} />
                <AsNavForSlider
                    eid={sk_eid_pc}
                    data1={products}
                    setting1={setting1}
                    setting2={setting2}>
                    {products.map((v, k) => {
                        return (
                            <div
                                className="item"
                                key={k}
                                onClick={() => {
                                    QNRSK.manual(sk_eid_pc);
                                    if (v.url_pc) {
                                        window.open(v.url_pc);
                                    }
                                }}>
                                <div className="container">
                                    <div className="title">
                                        <span className="iconfont ico-red">&#xe43a;</span>
                                        <span>{v.title}</span>
                                    </div>
                                    <p className="desc">{v.desc}</p>
                                </div>
                            </div>
                        );
                    })}
                </AsNavForSlider>
                <BtnMore url={more_url_pc} text="查看更多" eid="wj_hotriver_more" />
            </div>
        );
    }
}

// 当季优惠
class AdBanner extends React.Component {
    render() {
        const {data} = this.props;
        const {module_name, subtitle, products = [], sk_eid_pc} = data;
        if (!products || !products.length) {
            return false;
        }
        return (
            <div id="ad-banner">
                <Title title={module_name} subtitle={subtitle} />
                <div
                    className="m-ad m-wrap"
                    onClick={() => {
                        QNRSK.manual(sk_eid_pc);
                        window.open(products[0].url_pc);
                    }}>
                    <img src={products[0].img_pc} />
                </div>
            </div>
        );
    }
}

// 热门推荐
class HotRecommend extends React.Component {
    render() {
        const {data} = this.props;
        const {module_name, subtitle, products = [], more_url_pc, sk_eid_pc} = data;

        if (!products || !products.length) {
            return false;
        }
        return (
            <div id="hot-recommend">
                <Title title={module_name} subtitle={subtitle} />
                <div className="m-hot-recommend">
                    {products.map((v, k) => {
                        return (
                            <div
                                className="item"
                                key={k}
                                onClick={() => {
                                    QNRSK.manual(sk_eid_pc);
                                }}>
                                <div className="img-box">
                                    <img src={v.main_pic} />
                                    <div className="title">
                                        <div className="main">{v.sub_title}</div>
                                        <div className="desc">{v.title}</div>
                                    </div>
                                </div>
                                <div className="tag-box">
                                    {v.activityTag_original.map((v2, k2) => {
                                        return (
                                            <span key={k2} className="tag">
                                                {v2}
                                            </span>
                                        );
                                    })}
                                </div>
                                <div className="price-box">
                                    ￥<span className="price">{v.adult_price}</span>起
                                </div>
                                <div className="btn-box">
                                    <button
                                        className="btn-buy"
                                        onClick={() => {
                                            window.open(v.url);
                                        }}>
                                        立即抢购
                                    </button>
                                    <button
                                        className="btn-more"
                                        onClick={() => {
                                            window.open(v.more_url);
                                        }}>
                                        更多{v.arrive}特惠线路
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <BtnMore url={more_url_pc} text="查看更多" eid="wj_hotproduct_more" />
            </div>
        );
    }
}

// 达人游记
class TravelNotes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fold: true
        };
    }

    toggleFoldStatus() {
        this.setState({
            fold: !this.state.fold
        });
    }

    render() {
        const {data, limit} = this.props;
        const {fold} = this.state;
        const {module_name, subtitle, products = [], more_url_pc, sk_eid_pc} = data;

        if (!products || !products.length) {
            return false;
        }

        return (
            <div id="travel-notes">
                <Title title={module_name} subtitle={subtitle} />
                <div className="m-travel-notes">
                    {products.map((v, k) => {
                        return (
                            <div
                                className="item"
                                key={k}
                                style={{display: k + 1 > limit && fold ? 'none' : 'block'}}
                                onClick={() => {
                                    QNRSK.manual(sk_eid_pc);
                                    window.open(v.url_pc);
                                }}>
                                <div className="img-box">
                                    <img src={v.img_pc} />
                                    <div className="position">
                                        <i className="iconfont">&#xe43a;</i>
                                        &nbsp;{v.position}
                                    </div>
                                </div>
                                <div className="desc">{v.desc}</div>
                                <div className="user">
                                    <img src={v.img_header} />
                                    <div className="name">{v.user_name}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <BtnMore
                    url={more_url_pc}
                    text="查看更多"
                    isFold={fold}
                    callbackFn={() => {
                        this.toggleFoldStatus();
                    }}
                    eid="wj_gonglve_more"
                />
            </div>
        );
    }
}
// 游轮问答
class QuestionAnser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fold: true
        };
    }

    toggleFoldStatus() {
        this.setState({
            fold: !this.state.fold
        });
    }
    render() {
        const {data, limit} = this.props;
        const {fold} = this.state;
        const {module_name, subtitle, products = [], sk_eid_pc} = data;
        if (!products || !products.length) {
            return false;
        }
        return (
            <div id="question-anser">
                <Title title={module_name} subtitle={subtitle} />
                <div className="m-question-anser">
                    {products.map((v, k) => {
                        return (
                            <div
                                className="item"
                                key={k}
                                style={{display: k + 1 > limit && fold ? 'none' : 'block'}}
                                onClick={() => {
                                    QNRSK.manual(sk_eid_pc);
                                }}>
                                <div className="flex flex-q">
                                    <div className="icon">问</div>
                                    <div className="title">{v.question}</div>
                                </div>
                                <div className="flex flex-a">
                                    <div className="icon">答</div>
                                    <div className="desc">{v.anser}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <BtnMore
                    isFold={fold}
                    callbackFn={() => {
                        this.toggleFoldStatus();
                    }}
                />
            </div>
        );
    }
}

// 有关联的 slider
class AsNavForSlider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null
        };
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2
        });
    }

    render() {
        const {eid, data1, setting1, setting2} = this.props;
        return (
            <div className="sliders-box">
                <Slider
                    asNavFor={this.state.nav1}
                    ref={slider => (this.slider2 = slider)}
                    {...setting1}>
                    {data1.map((v, k) => {
                        return (
                            <div
                                className="item"
                                key={k}
                                onClick={() => {
                                    QNRSK.manual(eid);
                                    if (v.url_pc) {
                                        window.open(v.url_pc);
                                    }
                                }}>
                                <img src={v.img_pc} />
                            </div>
                        );
                    })}
                </Slider>
                <div className="slider2">
                    <Slider
                        asNavFor={this.state.nav2}
                        ref={slider => (this.slider1 = slider)}
                        {...setting2}>
                        {this.props.children}
                    </Slider>
                </div>
            </div>
        );
    }
}

class CustomArrow extends React.Component {
    render() {
        const {className, onClick, isNext} = this.props;
        return (
            <div className={className} onClick={onClick}>
                {isNext ? (
                    <div className="iconfont">&#xe1fd;</div>
                ) : (
                    <div className="iconfont">&#xe1fe;</div>
                )}
            </div>
        );
    }
}

// 弹出层
class PopupBox extends React.Component {
    render() {
        return (
            <div>
                <div className="mask" />
                <div className="content">{this.props.children}</div>
            </div>
        );
    }
}
// 侧边浮窗
@inject('store')
@observer
class Sidebar extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {appointForm, changeAppointForm, requestAppoint} = this.props.store;
        return (
            <div className="m-sidebar">
                <div className="wrap">
                    <div className="aside">
                        <div className="icon">
                            <div className="iconfont">&#xf3df;</div>
                            <div className="">预约咨询</div>
                        </div>
                        <div className="appoint-info">
                            <form class="form">
                                <input
                                    className="appoint-input"
                                    type="text"
                                    value={appointForm.username}
                                    placeholder="姓名"
                                    maxlength="5"
                                    onChange={e => changeAppointForm('username', e)}
                                />
                                <input
                                    type="text"
                                    value={appointForm.tel}
                                    placeholder="联系方式"
                                    maxlength="15"
                                    className="appoint-input"
                                    onChange={e => changeAppointForm('tel', e)}
                                />
                                <button
                                    type="button"
                                    className="appoint-btn"
                                    onClick={() => requestAppoint()}>
                                    预约
                                </button>
                            </form>
                        </div>
                    </div>
                    <div className="aside">
                        <div className="icon">
                            <div className="iconfont">&#xf052;</div>
                            <div className="">预约电话</div>
                        </div>
                        <div className="call-info">
                            <div className="iconfont">&#xf052;</div>
                            <div className="text">4008-196-355</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('app')
);
